import {
    Button,
    Dialog, 
    DialogActions, 
    DialogContent,
} from '@mui/material';

import {Trans} from 'react-i18next';

import EditWorkTimeModelTable from '../shared/EditWorkTimeModelTable';

function EditWorkHoursDialog({ open, onClose, user, onChange }) {

    return (
        <Dialog
            open={open}
            onClose={onClose}
            sx={{ w: 'fit-content' }}
        >
            <DialogContent
                sx={{ w: 'fit-content' }}
            >
                <EditWorkTimeModelTable
                    user={user}
                    onChange={onChange}
                />
            </DialogContent>
            <DialogActions>
                <Button variant='contained' onClick={onClose}>
                    <Trans ns='common' i18nKey='fertig'>Fertig</Trans>
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default EditWorkHoursDialog
